// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_4_wrapper__2LpPv"};